import { Card, Typography, theme } from '@fe-toolkit/web-components/ssr'

import { BroadbandPremise } from '@giffgaff/broadband-common'

export type InstallationAddressCardProps = {
  premise: Pick<BroadbandPremise, 'addressDisplay'> | undefined
}

const InstallationAddressCard = ({ premise }: InstallationAddressCardProps) => {
  return (
    <Card backgroundColor="white">
      <Typography as="h3" variant="whisper">
        Your address
      </Typography>
      <Typography data-di-mask as="p" marginBottom={theme.spacing.small} variant="speak">
        {premise?.addressDisplay?.join(', ')}
      </Typography>
    </Card>
  )
}

export default InstallationAddressCard
